<template lang="pug">
	div.page-statistics(v-if="USER")
		loading(:active="busy", :is-full-page="true")
		.widget
			.widget-body
				OvPageHeader(title="Offers")
				form.ov-filters(@submit.prevent="loadData()", :class="{expanded:filtersExpanded}")
					a.toggle-filters(href="javascript: void(0);", @click="toggleFilters()")
						span Filters
						i.la.la-chevron-up
					.form-row-main
						.ov-filter-field.ov-filter-field--wide
							label Search
							input.form-control(type="text", placeholder="Keyword...", v-model="filters.keyword")
						.ov-filter-field(v-if="isAdvertiser")
							label Status
							select.form-control(v-model="filters.status")
								option(v-for="o in advertiserStatusOptions", :value="o.v") {{ o.t }}
						.ov-filter-field(v-if="isAdvertiser")
							label Payout Model
							select.form-control(v-model="filters.payout_type")
								option(v-for="o in advertiserPayoutTypeOptions", :value="o.v") {{ o.t }}
						.ov-filter-field(v-if="!isAdvertiser")
							label Status
							select.form-control(v-model="filters.status")
								option(v-for="o in statusOptions", :value="o.v") {{ o.t }}
						.ov-filter-field(v-if="!isAdvertiser")
							label Countries
							input.form-control(type="text", v-model="filters.countries", placeholder="US, GB...")
						.ov-filter-field
							label OS
							select.form-control(v-model="filters.platform")
								option(v-for="o in platformOptions", :value="o.v") {{ o.t }}
					.form-row-end
						OvButton(variant="primary", type="submit") Go

				paginate(:paginator="paginate", @update-page-size="loadData")

				.ov-table-wrapper
					template(v-if="isAdvertiser")
						table.table.table-bordered.table-offer-list
							thead
								tr
									th ID
									th.col-icon &nbsp;
									th Name
									th OS
									th Bundle
									th Model
									th.c Payout
									th.col-status Status
									th(v-if="canEditAppnameBlacklist") Actions
							tbody
								tr(v-if="!records.length")
									td(:colspan="advertiserColspan") No matching records were found
								tr(v-for="r in records", v-bind:key="r.id")
									td.col-id
										span {{ r.id }}
										div.text-subtle(v-if="r.external_id") [{{ r.external_id }}]
									td.col-icon
										div.app-icon-container(v-if="r.icon")
											img(:src="r.icon")
										span(v-else) —
									td.col-name {{ r.name }}
									td {{ r.platform || '-' }}
									td
										span {{ r.bundle_id || '-' }}
									td {{ r.payout_type || '-' }}
									td.c
										quick-edit-payout(:r="r", @on-save="onSavePayout")
									td.col-status
										span.status-pill(:class="statusPillClass(r.status)") {{ statusLabel(r.status) }}
									td.actions(v-if="canEditAppnameBlacklist")
										span.d-inline-block(
											v-tooltip
											:title="r.appname_blwl_mode === 'blacklist' ? 'Edit Appname Blacklist' : 'Only available when app name list mode is Blacklist'"
										)
											a.btn.btn-action-primary(
												href="javascript:void(0)"
												:class="{ disabled: r.appname_blwl_mode !== 'blacklist' }"
												@click="r.appname_blwl_mode === 'blacklist' && openAppnameBlacklist(r)"
											)
												i.la.la-list-ul
						edit-appname-blacklist-modal(ref="editAppnameBlacklistModal")

					template(v-else)
						.tabs.table-tabs
							ul.nav.nav-tabs
								li.nav-item
									a.nav-link(:class="{active:selectedTab==='search'}", @click="selectedTab='search'") Search ({{ paginate.total }})
								li.nav-item
									a.nav-link(:class="{active:selectedTab==='bucket'}", @click="selectedTab='bucket'") Selected ({{ bucket.length }})
						table.table.table-bordered.table-offer-list
							thead
								tr
									th.col-select
										.col-select-head
											OvTableCheck(
												v-if="selectedTab==='search' && records.length",
												:checked="allOnPageSelected",
												:indeterminate="someOnPageSelected",
												@toggle="selectAll()",
												v-tooltip="'Select all on page'"
											)
											button.col-select-clear(
												v-if="bucket.length",
												type="button",
												@click="clearBucket()",
												v-tooltip="'Clear selection'"
											)
												i.la.la-times
									th ID
									th.col-icon &nbsp;
									th Name
									th.c Payout
									th Model
									th Payable Event
									th.c Geo
									th OS
									th.c Caps
									th.c(v-if="USER?.permissions?.['offers::CLICK_CAP']") ClickCap
									th WL/BL
									th.col-status Status
									th.c(v-if="USER?.permissions?.['offers::REDIRECTS']") Redirects
							tbody
								tr(v-if="selectedTab==='search' && !records.length")
									td(:colspan="tableColspan") No matching records were found
								tr(v-if="selectedTab==='bucket' && !bucket.length")
									td(:colspan="tableColspan") No offers selected. Use checkboxes in Search to add offers.
								tr(v-for="r in tableRows", v-bind:key="r.id", :class="{'row-selected': bucketHash[r.id]}")
									td.col-select(:class="{'bucket-row':bucketHash[r.id]}")
										OvTableCheck(:checked="!!bucketHash[r.id]", @toggle="toggleBucket(r)")
									td.col-id
										router-link(:to="{name:'offer-view', params: {id:r.id}}") {{ r.id }}
									td.col-icon
										div.app-icon-container(v-if="r.icon")
											img(:src="r.icon")
										span(v-else) —
									td.col-name {{ r.name }}
									td.c.col-payout(style="white-space: pre-wrap;") {{ payout(r) }}
									td {{ r.payout_type || '-' }}
									td.col-events(style="white-space: pre-wrap;") {{ payableEvents(r) }}
									td.c {{ r.country || '-' }}
									td {{ r.platform || '-' }}
									td.c {{ r.daily_cap ?? '-' }}
									td.c(v-if="USER?.permissions?.['offers::CLICK_CAP']") {{ r.daily_click_cap ?? '-' }}
									td &nbsp;
									td.col-status
										span.status-pill(:class="statusPillClass(r.status)") {{ statusLabel(r.status) }}
									td.c(v-if="USER?.permissions?.['offers::REDIRECTS']")
										span(v-if="r.scan_status === 1") {{ r.scan_nondirect_jumps }}

				paginate(:paginator="paginate", @update-page-size="loadData")
</template>
<script>
import { ovData } from '@/lib/ov-data';
import EditAppnameBlacklistModal from '../../components/modals/EditAppnameBlacklistModal.vue';
export default {
	name: 'OfferList',
	components: {
		// OfferScanModal,
		// OfferWLBLModal,
		// QuickConnectOffersModal,
		// CodeViewModal,
		// OfferExportModal
		EditAppnameBlacklistModal,
	},
	computed: {
		USER(){
			return this.$authStore.user;
		},
		isAdvertiser() {
			return this.USER.type === 'advertiser' || (this.USER.type === 'admin' && this.USER.advertiser_id);
		},
		advertiserStatusOptions(){
			return [
				{ v: 'all', t: 'All' },
				{ v: 'live', t: 'Live' },
				{ v: 'paused', t: 'Paused' },
			];
		},
		advertiserPayoutTypeOptions(){
			const options = [
				{ v: 'all', t: 'All' },
				{ v: 'CPA', t: 'CPA' },
				{ v: 'CPI', t: 'CPI' },
			];
			if (this.USER?.config?.cpmRevenue) {
				options.push({ v: 'CPM', t: 'CPM' });
			}
			return options;
		},
		numColumns(){
			return this.$authStore.user.permissions['offers::REDIRECTS'] ? 13 : 12;
		},
		canEditAppnameBlacklist(){
			return !!this.USER?.features?.allowEditAppnameBlacklist;
		},
		tableRows() {
			return this.selectedTab === 'bucket' ? this.bucket : this.records;
		},
		advertiserColspan() {
			return this.canEditAppnameBlacklist ? 9 : 8;
		},
		allOnPageSelected() {
			if (!this.records.length) return false;
			return this.records.every((r) => this.bucketHash[r.id]);
		},
		someOnPageSelected() {
			if (!this.records.length) return false;
			const n = this.records.filter((r) => this.bucketHash[r.id]).length;
			return n > 0 && n < this.records.length;
		},
		tableColspan() {
			let n = 12;
			if (this.USER?.permissions?.['offers::CLICK_CAP']) n++;
			if (this.USER?.permissions?.['offers::REDIRECTS']) n++;
			return n;
		},
	},
	data(){
		return {
			busy: false,
			paginate: {
				numPages: 0,
				total: 0,
				page: 1,
				limit: 50,
				onPageChange: () => {
					this.loadData();
				}
			},
			showAdvancedFilters: false,
			selectedTab: 'search',
			filters: {
				keyword: '',
				countries: '',
				platform: 'all',
				status: 'all',
				payout_type: 'all',
			},
			bucket: [],
			bucketHash: {},
			records: [],
			platformOptions: [
				{v: 'all', t: 'All'},
				{v: 'android', t: 'Android'},
				{v: 'ios', t: 'iOS'},
				{v: 'mobile_web', t: 'MobileWeb'},
				{v: 'desktop', t: 'Desktop'},
				{v: 'empty', t: 'Empty'},
			],
			statusOptions: [
				{v: 'all', t: 'All'},
				{v: 'live', t: 'Live'},
				{v: 'paused', t: 'Paused'},
				{v: 'ended', t: 'Ended'}
			],
			payoutModelOptions: ovData.general.payoutTypeOptions.map(o => {
				return {v: o.v, t: o.v}
			}),
			sortBy: {
				field: 'id',
				direction: 'desc',
				sort: null
			},
			filtersExpanded: false,
		};
	},
	methods: {
		statusPillClass(status) {
			const s = String(status || "").toLowerCase();
			const known = ["live", "paused", "ended", "draft", "cancelled"];
			return "status-pill--" + (known.includes(s) ? s : "default");
		},
		statusLabel(status) {
			const s = String(status || "").trim();
			return s || "-";
		},
		toggleFilters(){
			this.filtersExpanded = !this.filtersExpanded;
		},
		toggleBucket(r){
			if (this.bucketHash[r.id]) {
				this.bucketHash[r.id] = false;
				for (let i = 0; i < this.bucket.length; i++) {
					if (this.bucket[i].id === r.id) {
						this.bucket.splice(i, 1);
						return;
					}
				}
			} else {
				this.bucketHash[r.id] = true;
				this.bucket.push(r);
			}
		},
		clearBucket(){
			this.bucket = [];
			this.bucketHash = {};
		},
		selectAll(){
			if (this.allOnPageSelected) {
				this.records.forEach((r) => {
					if (!this.bucketHash[r.id]) return;
					this.bucketHash[r.id] = false;
					const idx = this.bucket.findIndex((b) => b.id === r.id);
					if (idx >= 0) this.bucket.splice(idx, 1);
				});
				return;
			}
			this.records.forEach((r) => {
				if (!this.bucketHash[r.id]) {
					this.bucketHash[r.id] = true;
					this.bucket.push(r);
				}
			});
		},
		async loadData(){
			this.busy = true;
			let params = {
				page: this.paginate.page,
				page_size: this.paginate.limit,
				keyword: this.filters.keyword,
				platform: this.filters.platform,
				countries: this.isAdvertiser ? undefined : this.filters.countries,
				status: this.filters.status,
				payout_type: this.isAdvertiser ? this.filters.payout_type : undefined,
				// has_blacklist: this.filters.has_blacklist ? 1 : 0,
				// has_whitelist: this.filters.has_whitelist ? 1 : 0,
				// show_hidden: this.filters.show_hidden ? 1 : 0,
				// smartlink: this.filters.smartlink ? 1 : 0,
				// countries: this.filters.countries,
				// status: this.filters.status,
				// validation_status: this.filters.validation_status,
				// platform: this.filters.platform,
				// payout_model: this.filters.payout_model,
				sort_col: this.sortBy.field,
				sort_dir: this.sortBy.direction,
				// max_redirects: this.filters.max_redirects,
				// offer_ids: this.filters.offer_ids,
				// offer_type: this.filters.offer_type,
				// complex_id: this.filters.complex_id,
				// mmp: this.filters.mmp
			};
			try {
				let path = this.isAdvertiser ? 'advertisers/offer/getList' : 'publishers/offer/getList';
				let resp = await this.$ovReq.get(path, {params});
				this.records = resp.records;
				this.records.forEach((rec) => this.syncCpaPayoutFields(rec));
				this.paginate.total = resp.total;
				this.paginate.numPages = Math.max(Math.ceil(this.paginate.total / this.paginate.limit), 1);
			} catch (e) {
				console.error(e);
			}
			this.busy = false;
		},
		payableEvents(r){			
			if (r.payout_type === 'CPI' || r.payout_type === 'CPM') {
				return r.payout_type === 'CPM' ? 'CPM' : 'Install';
			}
			return r.payable_events?.length ? r.payable_events.map(pe => pe.name).join('\n') : '-';
		},
		parsedOfferEvents(r) {
			return Array.isArray(r.events) ? r.events : [];
		},
		syncCpaPayoutFields(r) {
			if (r.payout_type !== 'CPA') {
				return;
			}
			const events = this.parsedOfferEvents(r);
			events.forEach((e, idx) => {
				if (e.payout_mode === 'fixed' && e.payout > 0) {
					r['cpa_payout_' + idx] = e.payout;
				}
			});
		},
		payout(r) {
			if (r.payout_type === 'CPI' || r.payout_type === 'CPM') {
				return r.payout;
			}
			const events = this.parsedOfferEvents(r);
			const payableEvents = events.filter((e) => e.payout_mode === 'fixed' && e.payout > 0);
			if (!payableEvents.length) {
				return 0;
			}
			return payableEvents.map((e) => e.payout).join(', ');
		},
		async onSavePayout(r, field) {
			try {
				// Save payout (field === 'payout')
				if (field === 'payout') {
					const val = Number(r._payout);
					const resp = await this.$ovReq.post('advertisers/offer/updateField', {
						id: r.id,
						field: 'payout',
						val,
					});
					r.payout = resp.entity?.payout ?? val;
					r._edit_payout = false;
					this.$ovNotify.success('Record has been updated');
					return;
				}

				// Save CPA event payout (field like 'cpa_payout_0', 'cpa_payout_1', etc.)
				const m = /^cpa_payout_(\d+)$/.exec(field);
				if (!m) {
					return;
				}
				const idx = Number(m[1]);
				const events = JSON.parse(JSON.stringify(this.parsedOfferEvents(r)));
				if (!events[idx]) {
					return;
				}
				events[idx].payout = Number(r['_' + field]);
				const resp = await this.$ovReq.post('advertisers/offer/updateField', {
					id: r.id,
					field: 'events',
					val: events,
				});
				let saved = resp.entity?.events ?? events;
				if (typeof saved === 'string') {
					try {
						saved = JSON.parse(saved);
					} catch (e) {
						saved = events;
					}
				}
				r.events = saved;
				this.syncCpaPayoutFields(r);
				r['_edit_' + field] = false;
				this.$ovNotify.success('Record has been updated');
			} catch (e) {
				this.$ovNotify.error(e);
			}
		},
		openAppnameBlacklist(r){
			this.$refs.editAppnameBlacklistModal.open(r);
		},
	},

	mounted(){
		this.loadData();
	},
	created(){
	}
}
</script>
